module.exports = __webpack_public_path__ + "img/ic-linechart.76a54c0a.svg";